package one.healthium.insights.ui.shopping_list.components

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.insights.ui.shopping_list.models.CategoriesUiModel
import one.healthium.insights.ui.shopping_list.models.CategoryUiModel
import one.healthium.loco.asLString
import one.healthium.loco.resolve
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_3
import one.healthium.ui.compose.theme.white
import androidx.compose.ui.tooling.preview.Preview

@Composable
internal fun CategoriesItem(
    uiModel: CategoriesUiModel,
    contentPadding: PaddingValues = PaddingValues.Zero,
    onCategoryClicked: (CategoryUiModel) -> Unit,
) {
    LazyRow(
        contentPadding = contentPadding,
    ) {
        items(uiModel.categories.size) { index ->
            val category = uiModel.categories[index]

            if (index > 0) {
                Spacer(modifier = Modifier.width(6.dp))
            }

            CategoryItem(
                category = category,
                isSelected = category.id == uiModel.currentCategoryId,
                onClick = { onCategoryClicked(category) },
            )
        }
    }
}

@Composable
private fun CategoryItem(
    category: CategoryUiModel,
    isSelected: Boolean,
    onClick: () -> Unit,
) {
    AppButton(
        onClick = onClick,
        minHeight = 36.dp,
        colors = if (isSelected) {
            AppButtonDefaults.appButtonColors(
                containerColor = AppTheme.colors.primary,
                contentColor = AppTheme.colors.onPrimary,
            )
        } else {
            AppButtonDefaults.appButtonColors(
                containerColor = white,
                contentColor = gray_3,
            )
        },
        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 9.dp),
    ) {
        Text(
            text = category.name.resolve(),
            style = AppTheme.textStyles.secondary_14_500,
        )
    }
}

@Composable
@Preview(showBackground = true)
private fun CategoriesItemPreview() {
    AppTheme {
        CategoriesItem(
            uiModel = CategoriesUiModel(
                categories = listOf(
                    CategoryUiModel(id = "1", name = "Fruits".asLString()),
                    CategoryUiModel(id = "2", name = "Vegetables".asLString()),
                    CategoryUiModel(id = "3", name = "Dairy".asLString()),
                    CategoryUiModel(id = "4", name = "Bakery".asLString()),
                    CategoryUiModel(id = "5", name = "Meat".asLString()),
                ),
                currentCategoryId = "3",
            ),
            onCategoryClicked = {},
        )
    }
}